import {Component, OnInit} from '@angular/core';
import {ReasonService} from "../../services/reason.service";
import {Reason} from "../../entities/reason";
import {of} from "rxjs";

@Component({
  selector: 'app-reason-board',
  standalone: true,
  imports: [],
  templateUrl: './reason-board.component.html',
  styleUrl: './reason-board.component.css'
})
export class ReasonBoardComponent implements OnInit {
  constructor(private reasonService: ReasonService) {}

  reasons?: Reason[];

  ngOnInit(): void {
    this.reasonService.getReasonsForMe().then(p => {
      p.forEach(PBreason=>{
        let reason: Reason = PBreason;
        this.reasonService.getUserById(PBreason.createdFrom).then(user=>{
          reason.ersteller = user?.username
        })
        this.reasonService.getTopic(PBreason.topic).then(topic=>{
          reason.topic = topic?.topicname ?? ""
        })
      })
      this.reasons = p;
    }).catch(() => {
      //TODO Fehlermeldung
      return of();
    })
  }

  openReason(id: String) {
    this.reasonService.openReason(id)
  }
}
